<template>
  <div class="aiAssistant div-layout">
    <div class="aiAssistant-main">
      <module-title title="AI语音助手技能提示">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit('add')"
          >
            发布
          </el-button>
        </div>
      </module-title>
      <div>
        <BaseTable
          v-loading="listLoading"
          class="list-table"
          :columns="columns"
          :data="dataList"
          border
        >
          <template #default="scope">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-edit"
              @click="opAddOrEdit('edit', scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              size="small"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </BaseTable>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 新增编辑 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="hiddenVariable.title"
      width="650px"
    >
      <dialog-info
        :type="hiddenVariable.type"
        :data-list="hiddenVariable.text"
        @closeDialog="closeDialogFn"
      />
    </el-dialog>
  </div>
</template>

<script>

import DialogInfo from './components/dialogInfo';
import { columns } from './store';

// 获取API
import {
  deskPromptList,
  deskPromptDel
} from '@/api/productOperation/mrDesk/aiAssistant';
export default {
  name: 'AiAssistant',
  components: {
    DialogInfo
  },
  data() {
    return {
      // 弹框标题
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false, // 学生详情
        type: 'add',
        id: '',
        title: '',
        text: {}
      },
      // 搜索表单
      searchForm: {
        id: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      dataList: [],
      listLoading: false, // 表格刷新loading
      // 表格
      columns
    };
  },

  mounted() {
    this.getInfo();
  },
  methods: {
    // 获取列表
    getInfo() {
      var option = {
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      deskPromptList(option)
        .then((res) => {
          this.listLoading = false;
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.dataList = [];
            this.searchForm.total = 0;
          } else {
            this.dataList = res.data.list;
            this.searchForm.total = res.data.total;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          this.listLoading = false;
          console.log(err);
        });
    },

    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getInfo();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getInfo();
    },

    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.ajaxLoading = false;
      this.hiddenVariable.title = type === 'add' ? ' 发布' : '编辑';
      this.hiddenVariable.type = type;
      if (type === 'edit') {
        this.hiddenVariable.text = row;
      } else {
        this.hiddenVariable.text = {};
      }

      this.hiddenVariable.dialogEditVisible = true;
    },
    // 删除
    handleDelete(row) {
      this.$confirm(`确定要删除该AI语音助手技能提示么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = {
            id: row.id
          };
          return deskPromptDel(form);
        })
        .then((res) => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.getInfo();
        })
        .catch(() => {});
    },
    // 弹框关闭
    closeDialogFn() {
      this.hiddenVariable.dialogEditVisible = false;
      this.getInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.aiAssistant {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}

.header-top {
  display: flex;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 30px;
  text-align: center;
  align-items: center;
  .tabs-panle {
    flex: 1;
    .tabs-wraper {
      height: 42px;
      line-height: 42px;
      text-align: center;
      display: inline-block;
      padding: 0 10px;
      span {
        padding: 0 30px;
        height: 42px;
        line-height: 42px;
        display: inline-block;
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
      }
      .frist {
        border-radius: 20px 0 0 20px;
        border-left: 1px solid #e5e5e5;
      }
      .last {
        border-radius: 0 20px 20px 0;
        border-right: 1px solid #e5e5e5;
      }
      .active {
        background: #409eff;
        color: #fff;
      }
    }
  }
}
</style>

